<template>
  <b-button variant="outline-info" v-on:click="pressed">{{$t("EDIT")}}</b-button>
</template>
<script>

export default {
  props: ["ClassId", "token"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      this.$router.push({ path: "/classes/" + this.ClassId });
    }
  }
};
</script>